module.exports = __webpack_public_path__ + "static/media/pix-error.ac0b2c29.svg";